// Shims previously injected by @vitejs/plugin-legacy's `modernPolyfills`,
// dropped during the Vite 8 upgrade, plus shims for APIs our dependencies
// rely on. Binding feature is Object.hasOwn (Safari 15.4+, Chrome 93+,
// Firefox 92+, Samsung Internet 17+) — affects ~0.02% of prod sessions.

export function applyPolyfills(): void {
  if (!Promise.allSettled) {
    Promise.allSettled = <T>(
      promises: Iterable<T | PromiseLike<T>>,
    ): Promise<PromiseSettledResult<Awaited<T>>[]> =>
      Promise.all(
        [...promises].map((p) =>
          Promise.resolve(p).then(
            (value) => ({ status: "fulfilled" as const, value }),
            (reason) => ({ status: "rejected" as const, reason }),
          ),
        ),
      )
  }

  // reka-ui's useForwardExpose() calls Object.hasOwn(ref, "$el") on every
  // template ref it forwards, so a missing binding throws inside the render
  // effect and the app never mounts on Safari <15.4 / Chrome <93.
  // https://soenergy.atlassian.net/browse/SO-32810
  if (!Object.hasOwn) {
    Object.hasOwn = (object: object, property: PropertyKey): boolean =>
      Object.prototype.hasOwnProperty.call(object, property)
  }

  if (!Object.fromEntries) {
    Object.fromEntries = <T = unknown>(
      entries: Iterable<readonly [PropertyKey, T]>,
    ): Record<PropertyKey, T> => {
      const result: Record<PropertyKey, T> = {}
      for (const [key, value] of entries) result[key] = value
      return result
    }
  }
}

applyPolyfills()
